'use client';

import { useZmyleCookieStore } from '@/hooks/useZmyleCookieStore';
import { ClientConfig } from '@/services/clientConfig';

import { FacebookPixel } from './FacebookPixel';
import { GoogleTagManager } from './GoogleTagManager';
import { isGoogleAdsEnabled } from './lib';
import { LinkedInInsight } from './LinkedInInsight';

interface Props {
  nonce: string | null;
}

export const MarketingScripts = (props: Props) => {
  const { nonce } = props;

  const zmyleCookie = useZmyleCookieStore(state => state.zmyleCookie);

  const { marketing } = zmyleCookie.consents;

  const clientConfig = ClientConfig.getInstance().getConfig();

  const isFacebookPixelEnabled =
    Boolean(clientConfig.facebookPixelId) &&
    marketing.includes('facebook-pixel');

  const isLinkedinInsightEnabled =
    Boolean(clientConfig.linkedinPartnerId) &&
    marketing.includes('linkedin-insight-tag');

  return (
    <>
      {isGoogleAdsEnabled(zmyleCookie) && <GoogleTagManager nonce={nonce} />}

      <FacebookPixel isEnabled={isFacebookPixelEnabled} />

      <LinkedInInsight isEnabled={isLinkedinInsightEnabled} />
    </>
  );
};
